export enum WebsiteGuideParams {
    BASE = "guide"
}